import hue from './hue';
import saturation from './saturation';
import value from './value';



let executerMap = {
  'groupHue':hue,
  'groupSaturation':saturation,
  'groupValue':value,
}

let filters = {};

for(let key in executerMap){
    filters[key] = executerMap[key].execute;
}



let setBase = (filterName, base) =>{
  if(executerMap[filterName]){
    executerMap[filterName].setBase(base);
  };
}
export default {filters, setBase}
